import { render } from "./AddressBook.html?vue&type=template&id=4d6ec6c3&scoped=true"
import script from "./AddressBook.js?vue&type=script&lang=js"
export * from "./AddressBook.js?vue&type=script&lang=js"

import "./AddressBook.css?vue&type=style&index=0&id=4d6ec6c3&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-customer-portal/src/ST.PetroNetworkCustomer.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d6ec6c3"]])

export default __exports__